import React, { useState } from "react";

function FormPreview({ schema }) {
  const [formData, setFormData] = useState({});

  const getFieldConditions = (field) => {
    if (Array.isArray(field.when_any) && field.when_any.length > 0) {
      return field.when_any;
    }
    if (field.when) {
      return [field.when];
    }
    return [];
  };

  const evaluateCondition = (condition) => {
    if (!condition?.field) return false;
    const dependentFieldValue = formData[condition.field];

    if (dependentFieldValue === undefined || dependentFieldValue === null || dependentFieldValue === "") {
      return false;
    }

    if (condition.equals !== undefined) {
      return dependentFieldValue === condition.equals;
    }

    if (condition.not_equals !== undefined) {
      return dependentFieldValue !== condition.not_equals;
    }

    if (condition.in !== undefined && Array.isArray(condition.in)) {
      return condition.in.includes(dependentFieldValue);
    }

    if (condition.not_in !== undefined && Array.isArray(condition.not_in)) {
      return !condition.not_in.includes(dependentFieldValue);
    }

    return false;
  };

  // Проверка, должно ли поле быть видимым
  const isFieldVisible = (field) => {
    const conditions = getFieldConditions(field);
    if (conditions.length === 0) {
      return true;
    }
    // Логика ветвления: достаточно выполнения любого условия (OR).
    return conditions.some((condition) => evaluateCondition(condition));
  };

  const handleFieldChange = (fieldId, value) => {
    setFormData({ ...formData, [fieldId]: value });
  };

  if (!schema || !schema.fields || !Array.isArray(schema.fields)) {
    return (
      <div className="text-center py-8 text-blue-400 border-2 border-dashed border-blue-200 rounded-md">
        <p>Добавьте поля в схему для предпросмотра</p>
      </div>
    );
  }

  const visibleFields = schema.fields.filter((field) => isFieldVisible(field));
  const hasVisibleInputFields = visibleFields.some((field) => field.type !== "step_separator");

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-blue-700 mb-4">Предпросмотр формы</h3>
      <div className="bg-white rounded-lg border border-blue-200 p-6">
        {visibleFields.map((field, index) => {
            const fieldId = field.id || field.name || `field_${index}`;

            if (field.type === "step_separator") {
              return (
                <div key={fieldId} className="my-6 flex items-center gap-3">
                  <div className="h-px bg-blue-200 flex-1" />
                  <span className="text-xs text-blue-500 uppercase tracking-wide">
                    {field.label || "Следующий шаг"}
                  </span>
                  <div className="h-px bg-blue-200 flex-1" />
                </div>
              );
            }

            return (
              <div key={fieldId} className="mb-4">
                <label className="block text-sm font-medium text-blue-700 mb-1">
                  {field.label || fieldId}
                  {field.required && <span className="text-red-500 ml-1">*</span>}
                </label>

                {field.type === "file" ? (
                  <input
                    type="file"
                    className="w-full py-2 px-3 border border-blue-200 rounded-md bg-blue-50 text-blue-700 focus:ring-2 focus:ring-blue-200 outline-none file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-500 file:text-white hover:file:bg-blue-600"
                    required={field.required}
                    accept={field.accept || "*/*"}
                    disabled
                  />
                ) : field.type === "select" ? (
                  <select
                    value={
                      formData[fieldId] !== undefined && formData[fieldId] !== null && formData[fieldId] !== ""
                        ? formData[fieldId]
                        : (field.default ?? field.default_value ?? "")
                    }
                    onChange={(e) => handleFieldChange(fieldId, e.target.value)}
                    className="w-full py-2 px-3 border border-blue-200 rounded-md bg-blue-50 text-blue-700 focus:ring-2 focus:ring-blue-200 outline-none"
                    required={field.required}
                  >
                    <option value="">{field.placeholder || "Выберите..."}</option>
                    {field.options &&
                      field.options.map((option, optIndex) => {
                        const optionValue =
                          typeof option === "string" ? option : option.value;
                        const optionLabel =
                          typeof option === "string" ? option : option.label;
                        return (
                          <option key={optIndex} value={optionValue}>
                            {optionLabel || optionValue}
                          </option>
                        );
                      })}
                  </select>
                ) : field.type === "textarea" ? (
                  <textarea
                    value={formData[fieldId] || ""}
                    onChange={(e) => handleFieldChange(fieldId, e.target.value)}
                    className="w-full py-2 px-3 border border-blue-200 rounded-md bg-blue-50 text-blue-700 focus:ring-2 focus:ring-blue-200 outline-none"
                    rows={field.rows || 4}
                    required={field.required}
                    placeholder={field.placeholder}
                  />
                ) : (
                  <input
                    type={field.type || "text"}
                    value={formData[fieldId] || ""}
                    onChange={(e) => handleFieldChange(fieldId, e.target.value)}
                    className="w-full py-2 px-3 border border-blue-200 rounded-md bg-blue-50 text-blue-700 focus:ring-2 focus:ring-blue-200 outline-none"
                    required={field.required}
                    placeholder={field.placeholder}
                  />
                )}

                {field.description && (
                  <p className="text-xs text-blue-400 mt-1">{field.description}</p>
                )}
              </div>
            );
          })}

        {!hasVisibleInputFields && (
          <div className="text-center py-8 text-blue-400">
            <p>Нет видимых полей. Заполните зависимые поля для отображения.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default FormPreview;

